<template>
  <div class="">
  <div id="mySidenav" :class="{activesidenav : isfilter}" class="sidenav">
    <div id="closesidebar">
            <a  class="closebtn" @click="closeNav()">&times;</a>
    <!-- <a>Filters</a> -->
            <div style="position:relative">
              <a>Filters</a>
              <div style="bottom: 6px;background:#DADADA;" class="underline"></div>
            </div>
            <div v-if="typeof mentororinvest !== 'undefined'">
              <a  v-for="(val,index) in mentororinvest" > 
                <b-checkbox  v-model="ismenorinvest"
                  :native-value="val">
                  <!-- {{ val}} -->
                    {{ val.label }}
                </b-checkbox>
              </a>
            </div>
            <div v-if="ishideinvestmentmenu" style="position:relative">
              <a> Interested in investing</a> 
              <div style="bottom: 6px;background:#DADADA;" class="underline"></div>
            </div>
            <div v-if="ishideinvestmentmenu && typeof interestedinvesting.value !== 'undefined'">
              <a   v-for="(val,index) in interestedinvesting.value.slice(0,numberclickinterest)" > 
                <b-checkbox  v-model="investing"
                  :native-value="val">
                    {{ val.label }}
                </b-checkbox>
              </a>
            </div>

            <a v-if="ishideinvestmentmenu && showmoreInterest" @click="clickinterested()"  >
               <span style="color:#0D6ACA;font-size:15px">
                Show all
               </span>
             </a>
             <a v-if="ishideinvestmentmenu && !showmoreInterest" @click="clickhideinterested()"  >
               <span style="color:#0D6ACA;font-size:15px">
                Hide
               </span>
             </a>
           

            <div v-if="ishideinvestmentmenu" style="position:relative">
            <a>Size of investment </a>
            <div style="bottom: 6px;background:#DADADA;" class="underline"></div>
            </div>
             <a v-if="ishideinvestmentmenu"  v-for="(val,index) in sizeinvestment" > 
               <b-checkbox  v-model="issize"
                :native-value="val">
                  {{ val.label }}
               </b-checkbox> 
            </a>
             
             
      <div style="position:relative">
      <a >PRICING</a>
      <div style="bottom: 6px;background:#DADADA;" class="underline"></div>
      </div>
         <!--  <b-field label="">
            <b-select placeholder="Currency" v-model="obj_filter.currency">
                <option v-for="data in currency"
                    :value="data.code">
                    {{data.code}}
                </option>
            </b-select>
          </b-field> -->
            <b-checkbox v-model="filterPrice"
              :native-value="'free'">
              Free
            </b-checkbox>
            <b-checkbox v-model="filterPrice"
              :native-value="'hiring'">
              Hiring
            </b-checkbox>
            <!-- <a>
            <b-radio name="price" v-model="obj_filter.price"
                native-value="free">
                free
            </b-radio>
              </a>
            <a > <b-radio name="price"  v-model="obj_filter.price"
                native-value="<25$">
                < 25$
            </b-radio>
            </a>
             <a > <b-radio name="price"  v-model="obj_filter.price"
                native-value="25$-50$">
                25$ - 50$
            </b-radio>
            </a>
             <a > <b-radio name="price"  v-model="obj_filter.price"
                native-value="50$-100$">
                50$ - 100$
            </b-radio>
            </a>
             <a > <b-radio name="price"  v-model="obj_filter.price"
                native-value="100$ +">
              100$ +
            </b-radio>
            </a> -->
            
            <div style="position:relative">
            <a >TALK IN YOUR LANGUAGE</a>
            <div style="bottom: 6px;background:#DADADA;" class="underline"></div>
            </div>
             <a  class="language" v-for="(val,index) in getlanguageDynamic.slice(0,numberclick)" > 
                <b-checkbox  v-model="filterLang"
                :native-value="val.label">
                    {{ val.label }}
                </b-checkbox></a>
             <a @click="clickshowall()" v-if="showmore" >
               <span style="color:#0D6ACA;font-size:15px">
                Show all
               </span>
             </a>
             <a @click="clickhide()" v-if="!showmore" >
               <span style="color:#0D6ACA;font-size:15px">
                Hide
               </span>
             </a>

          <div style="position:relative">
            <a >Skills</a>
            <div style="bottom: 6px;background:#DADADA;" class="underline"></div>
          </div>
          <a>
            <b-checkbox name="industry" v-model="filterSkill"
                native-value="Advice on Funding">
                Advice on Funding
            </b-checkbox>
              </a>
            <a > <b-checkbox name="industry"  v-model="filterSkill"
                native-value="Content Marketing">
                Content Marketing
            </b-checkbox>
            </a>
             <a > <b-checkbox name="industry"  v-model="filterSkill"
                native-value="Branding">
                Branding
            </b-checkbox>
            </a>
             <a > <b-checkbox name="industry"  v-model="filterSkill"
                native-value="Growth Hacking">
                Growth Hacking
            </b-checkbox>
            </a>
             <a > <b-checkbox name="industry"  v-model="filterSkill"
                native-value="Design/UX">
              Design/UX
            </b-checkbox>
            </a>
            <a > <b-checkbox name="industry"  v-model="filterSkill"
                native-value="Product Management">
              Product Management
            </b-checkbox>
            </a>
            <a > 
              <b-checkbox name="industry"  v-model="filterSkill"
                native-value="Product Market Fit">
              Product Market Fit
            </b-checkbox>
            </a>
            <a > <b-checkbox name="industry"  v-model="filterSkill"
                native-value="Technology and Tools">
              Technology and Tools
            </b-checkbox>
            </a>
            <a > 
              <b-checkbox name="industry"  v-model="filterSkill"
                native-value="Legal">
              Legal
            </b-checkbox>
            </a>
            <a > <b-checkbox name="industry"  v-model="filterSkill"
                native-value="Accounting and Tax">
              Accounting and Tax
            </b-checkbox>
            </a>
            <a > 
              <b-checkbox name="industry"  v-model="filterSkill"
                native-value="Import/Export">
              Import/Export
            </b-checkbox>
            </a>
               <b-button @click="clearfilters" type="is-info" class="orangebutton" outlined>
          CLEAR ALL FILTERS
           </b-button>
  </div>
</div>
    <div  style="margin-bottom:0;margin-top: 100px;;height: 60px;">
      <div class="column is-12">
        <div class="columns">
          <div class="column is-6 has-text-centered-mobile">
             <strong>{{filtersizeofinvestment.length}} MENTORS FOUND </strong>
          </div>
          <div class="column is-6">
            <b-button  @click="openNav()" :class="{activefilter : isfilter }" id="Filters" class="Filters" type="is-info">
              <span class="">
              <i class="fas fa-filter"></i> 
                FILTERS 
              </span>
            </b-button>
          </div>
        </div>
      </div>
    </div>

        <div  style="margin-top:30px;" class="column">
            <div style="margin-right: 10px;" v-if="filterPrice" v-for="(val,index) in filterPrice" :key="index" class="objfilter">
              <div  style="text-align: left;">" {{val}} " <i @click="remove('price',index)" class="fas fa-times-circle"></i></div>
            </div>
            <div style="margin-right: 10px;"  v-for="(val,index) in filterLang" class="objfilter" :key="index">
               <div  style="text-align: left;">" {{val}} " <i @click="remove('language',index)" class="fas fa-times-circle"></i></div>
            </div>
            <div style="margin-right: 10px;" v-if="obj_filter.currency" class="objfilter">
                <div  style="text-align: left;">" {{obj_filter.currency }} " <i @click="remove('currency')" class="fas fa-times-circle"></i></div>
            </div>
            <div style="margin-right: 10px;" v-for="(val,key) in filterSkill" class="objfilter" :key="key">
                <div  style="text-align: left;">" {{val}} " <i @click="remove('skill',key)" class="fas fa-times-circle"></i></div>
            </div>
            <div style="margin-right: 10px;" v-for="(val,ii) in investing"   class="objfilter" :key="ii">
                <div  style="text-align: left;" >" {{ val.label }} " <i @click="remove('investing',ii)" class="fas fa-times-circle"></i></div>
            </div>
             <div style="margin-right: 10px;" v-for="(val,dd) in ismenorinvest"  class="objfilter" :key="dd">
                <div  style="text-align: left;" >" {{ val.label }} " <i @click="remove('ismenorinvest',dd)" class="fas fa-times-circle"></i></div>
            </div>
             <div style="margin-right: 10px;" v-for="(val,cc) in issize"  class="objfilter" :key="cc">
                <div  style="text-align: left;" >" {{ val.label }} " <i @click="remove('issize',cc)" class="fas fa-times-circle"></i></div>
            </div>

        </div>
<div class="pd-4">
  <article :class="{mb : index+1 == filtersizeofinvestment.length,blurprofile: index > islogin,'is-hidden-mobile':widthMax < 1024 && index > 2 }" class="columns mg-y-5 " v-for="(val,index) in filtersizeofinvestment"   style="margin-bottom: 1rem;" :key="index" >
    <b-button @click="gopath('/signin',index)" class="blurbutton" v-if="index > islogin" type="is-primary">
      SIGN IN TO VIEW PROFILE
    </b-button>
    <figure  class="media-left blurcontent column is-2">
      <div class="is-140x140">   
        <div class="profileContent" v-if="typeof val.detailUser[0].profilePic != 'undefined' && val.detailUser[0].profilePic != ''" >
          <img :src="imgPath+val.detailUser[0].profilePic" class="mg-x-auto">
        </div>
        <div v-else class="profileContent">
          <img src="@/assets/user.png" class="mg-x-auto">
        </div>
        <div style="margin:15px 0px 5px 0;">
          <span v-if="val.detailUser[0].amountHourly != null && typeof val.detailUser[0].amountHourly != 'undefined'"><strong>Price</strong>&nbsp;<span v-html="currencySymbol(val.detailUser[0].hourlyRate)">&nbsp;</span>{{val.detailUser[0].amountHourly | comma}}/hour</span>
          <span v-else >Free</span>
        </div> 
          <b-button v-if="isstatelogin.token && isstatelogin.userLevel == 0"  @click="checkisuserticket(val)"  type="is-info" class="Filters marginfilter" style="float: inherit;margin-top:10px" id="Filters"  outlined>
            <span class="" >Booking Mentor</span>
         </b-button>
      </div>
    </figure>  
      <div class=" blurcontent column">
        <div class="content" style="position:relative">
          <div class="width_mobile" style="margin-bottom: 33px;">
            <div class="columns mg-b-0 has-text-centered-mobile">
              <div class="column pd-b-0 is-9 is-size-5">
                <strong class="th text-capitalize">{{ val.detailUser[0].name  }} {{ val.detailUser[0].surname  }}</strong>
                <span v-if="val.reviewPoints > 0" class="font-size-15 is-block-mobile " :class="widthMax > 767 ? '':'mg-t-10'"> Rating 
                    <span class="mr-2 star-gray">
                      <i class="fas fa-star mg-r-8" :class="{'text-orange':val.reviewPoints > 0}"></i>
                      <i class="fas fa-star mg-r-8" :class="{'text-orange':val.reviewPoints > 1}"></i>
                      <i class="fas fa-star mg-r-8" :class="{'text-orange':val.reviewPoints > 2}"></i>
                      <i class="fas fa-star mg-r-8" :class="{'text-orange':val.reviewPoints > 3}"></i>
                      <i class="fas fa-star mg-r-8" :class="{'text-orange':val.reviewPoints > 4}"></i>
                    </span>
                    ({{val.reviewPoints | floatNumber}})
                </span> 
                <span v-else class="is-size-7 has-text-grey-light is-block-mobile is-hidden-mobile" :class="widthMax > 767 ? '':'mg-t-10'">
                    No rate yet
                </span>
              </div>
              <div class="column pd-b-0 is-3 has-text-right-tablet has-text-centered-mobile " :class="widthMax>767?'':'is-block mg-b-3'">
                <span v-if="userLogin !== '' && userLogin !== null" @click="viewprofile(val,index)"  class="hoverView marginfilter mg-r-10 cursor is-size-7">
                  <span >View profile </span>
                </span>
              </div>
            </div>
            <div class="" v-if="val.detailUser[0].professionTitle != '' && val.detailUser[0].professionTitle != null && typeof val.detailUser[0].professionTitle != 'undefined'">"{{val.detailUser[0].professionTitle}}"</div>
            <div class="columns">
              <div class="column th" v-if="val.detailUser[0].living != '' && typeof val.detailUser[0].living != 'undefined'">
                Living in: <span v-if="val.detailUser[0].living != '' && typeof val.detailUser[0].living != 'undefined'">{{ val.detailUser[0].living }}</span>
              </div>
            </div>
            <div class="columns ">
              <div class="column" v-if="val.detailUser[0].language != null && typeof val.detailUser[0].language != 'undefined' && val.detailUser[0].language.length > 0" >
                <!-- {{ val.detailUser[0].industryExpertise }} ${comma(data.name,index,indexlangage)}--> 
              Talk well in: <span v-for="(data,indexlangage) in val.detailUser[0].language" :key="indexlangage">{{data.name}}<span v-if="indexlangage != val.detailUser[0].language.length-1">, </span></span>
              <!-- {{ val.language}} -->
              </div>
            </div>
          <nav class="level is-mobile">
          <div class="level-left" v-if="typeof val.detailUser[0].social != 'undefined'">
            <b-tooltip v-if="val.detailUser[0].social.facebook && val.detailUser[0].social.facebook != null && typeof val.detailUser[0].social.facebook != 'undefined' && typeof val.detailUser[0].social != 'undefined'" 
              class="info-invest" 
              :label="'https://'+val.detailUser[0].social.facebook" 
              position="is-bottom" 
              type="is-info">
              <a  class="level-item">
                  <div class="circle">
                  <i class="fab fa-facebook-f"></i>
                  </div>
              </a>
            </b-tooltip>
            <b-tooltip v-if="val.detailUser[0].social.linkedin && val.detailUser[0].social.linkedin != null && typeof val.detailUser[0].social.linkedin != 'undefined' && typeof val.detailUser[0].social != 'undefined'" 
              class="info-invest" 
              :label="'https://'+val.detailUser[0].social.linkedin" 
              position="is-bottom" 
              type="is-info">
              <a class="level-item">
                <div class="circle">
                  <i class="fab fa-linkedin-in"></i>
                </div>
              </a>
            </b-tooltip>
            <b-tooltip v-if="val.detailUser[0].social.line && val.detailUser[0].social.line != null && typeof val.detailUser[0].social.line != 'undefined' && typeof val.detailUser[0].social != 'undefined'"  
              class="info-invest" 
              :label="val.detailUser[0].social.line" 
              position="is-bottom" 
              type="is-info">             
              <a class="level-item">
                  <div class="circle">
                  <i class="fab fa-line"></i>
                  </div>
              </a>
            </b-tooltip>
            <b-tooltip v-if="val.detailUser[0].social.skype  && val.detailUser[0].social.skype != null && typeof val.detailUser[0].social.skype != 'undefined' && typeof val.detailUser[0].social != 'undefined'" 
              class="info-invest" 
              :label="val.detailUser[0].social.skype" 
              position="is-bottom" 
              type="is-info">
              <a  class="level-item">
                  <div class="circle">
                  <i class="fab fa-skype"></i>
                  </div>
              </a>
            </b-tooltip>
            <b-tooltip  v-if="val.detailUser[0].social.hangouts && val.detailUser[0].social.hangouts != null && typeof val.detailUser[0].social.hangouts != 'undefined' && typeof val.detailUser[0].social != 'undefined'" 
              class="info-invest" 
              :label="val.detailUser[0].social.hangouts" 
              position="is-bottom" 
              type="is-info">
              <a  class="level-item">
                  <div class="circle">
                  <span>H</span> 
                  </div>
              </a>
            </b-tooltip>
            <b-tooltip v-if="val.detailUser[0].social.zoom && val.detailUser[0].social.zoom != null && typeof val.detailUser[0].social.zoom != 'undefined' && typeof val.detailUser[0].social != 'undefined'"
              class="info-invest" 
              :label="val.detailUser[0].social.zoom" 
              position="is-bottom" 
              type="is-info">
              <a    class="level-item">
                  <div class="circle">
                  <span>Z</span>
                  </div>
              </a>
            </b-tooltip>
          </div>
        </nav>
          </div> 
        </div>
        <div class="contenttext is-block-mobile"> 
          <div v-if="typeof val.detailUser[0].industryInterested != 'undefined' && val.detailUser[0].industryInterested != null &&  val.detailUser[0].industryInterested != ''"> Interested in investing:
            <span v-for="(item,index) in val.detailUser[0].industryInterested" :key="index" class="fontblue" style="display:inline-block;margin:2px 2px">
              {{ `${item.name}` }}<span v-if="index != val.detailUser[0].industryInterested.length-1">, </span>
            </span>
          </div>
          <div v-if="val.detailUser[0].sizeInvestment != null && typeof val.detailUser[0].sizeInvestment != 'undefined'  && val.detailUser[0].sizeInvestment != ''"> Size of investment: 
            <span v-for="(item,index) in val.detailUser[0].sizeInvestment" :key="index" class="fontblue" style="display:inline-block;margin:2px 2px">
              {{ `${item.name}`  }}<span v-if="index != val.detailUser[0].sizeInvestment.length-1">, </span>
            </span>
          </div>  
        </div>
        <hr/>
        <div class="contenttext is-block-mobile"> 
          <div v-if="val.detailUser[0].aboutMe != '' && typeof val.detailUser[0].aboutMe != 'undefined' && val.detailUser[0].aboutMe != null">
            {{val.detailUser[0].aboutMe}}
          </div> 
          <div class="mg-t-40">
            <div v-for="(data,index) in val.detailUser[0].industryExpertise" class="is-inline-block border-radius-small bg-grey-lighter is-size-7 pd-y-2 pd-x-3 mg-r-20 mg-y-1" :key="index">
              {{data.name}}
            </div>
          </div>
        </div>
      </div>
  </article>
  <div :class="widthMax > 1024 ? 'is-hidden-tablet':''" v-if="filtersizeofinvestment.length > 0">
     <b-button @click="gopath('/signin',index)" class="blurbutton mg-t-15" style="position: relative;" type="is-primary">
      SIGN IN TO VIEW MORE
    </b-button>
  </div>
</div>
   <b-modal :active.sync="isComponentModalActive" has-modal-card>
      <div class="modal-card">
          <section class="modal-card-body">
             <div class="columns">
                <div class="column">
                  <h2 class="has-text-centered is-size-3 has-text-weight-semibold has-text-dark">Booking</h2>
                </div>
              </div>
            <div class="columns has-text-centered">
                <div class="column">
                    <div class="cursor" @click="$router.push('booking/mentor')">
                      <div class="card-image">
                          <img src="@/assets/booking.png">
                      </div>
                      <div class="card-content">
                        <div class="media">
                          <div class="media-content">
                            <p class="title is-4  is-size-6 has-text-centered">Booking Mentor</p>
                          </div>
                        </div>
                      </div>
                    </div>
                </div>
                <div class="column">
                  <div class="cursor"  @click="checkisuserticket">
                    <div class="card-image">
                       <img src="@/assets/ticket.png">
                    </div>
                    <div class="card-content">
                      <div class="media">
                        <div class="media-content">
                          <p class="title is-4  is-size-6  has-text-centered">Go Ticket</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
             </section>
        </div>
  </b-modal>
   <!-- :can-cancel="false" -->
  <b-modal :active.sync="isComponentModalc" has-modal-card>
    <div class="modal-card" style="width: auto">
      <section class="modal-card-body">
        <button class="button is-warning">
          <b-icon
          pack="fas"
          icon="sync-alt"
          custom-class="fa-spin">
          </b-icon>
          <span>Synonyms for connect at Ticket</span>
        </button>
      </section>
    </div>
  </b-modal>
  </div>
</template>

<script>
import { HTTP,HTTPDynamic,HTTPMentor } from "@/axios";

export default {
    data() {
            return {
              widthMax: window.innerWidth,
              urlTicket:process.env.VUE_APP_BASEURL_TICKET,
              imgPath:process.env.VUE_APP_IMG_PROFILE,
              isComponentModalc:false,
              isComponentModalActive: false,
              isfilter:false,
              obj_filter: {
                price:null,
                language:null,
                industry:null,
                mentor:null,
              },
              investing:[],
              ismenorinvest:[],
              issize:[],
              filterLang:[],
              filterSkill:[],
              filterPrice:[],
              mentororinvest:[{
                label:'Mentor',
                value:true
              },{
                label:'Investor',
                value:true
              }],
              numberclick:10,
              numberclickinterest:10,
              showmore:true,
              showmoreInterest:true,
              value_mentor:[],
              interestedinvesting:[],
              sizeinvestment:[],
              registerticket:{
                name:'',
                surname:'',
                email:'',
                userLevel:'',
              }
            }
        },
        methods:{
          currencySymbol(val){
              let data = this.currency.filter(search =>{
                return search.code == val
              })
              return data[0].symbol
          },
          clickinterested(){
            this.numberclickinterest += this.getlanguageDynamic.length
            this.showmoreInterest = false
          },
          clickhideinterested(){
            this.numberclickinterest = 10
            this.showmoreInterest = true
          },
          checkisuserticket(value){
            let text = JSON.stringify(this.isstatelogin.detailUser[0])
            let objSend = JSON.parse(text)

            objSend['userLevel'] = this.isstatelogin.userLevel
            objSend['userIdExport'] = this.isstatelogin.typeSystem == 'inteGreat' ? this.isstatelogin.detailUser[0].userIdExport : this.isstatelogin.userId
            objSend['typeSystem'] = this.isstatelogin.typeSystem
            objSend['projectCode'] = 'oZcIppU-VBIx9KO'

            if(value != ''){
              let mentorDetail = {
                mentorId:value.userId,
                userLevel:value.userLevel,
                ...value
              }
              objSend['mentorDetail'] = mentorDetail
            }
            console.log('objSend',objSend)
            var jwt = require('jsonwebtoken');
            var secret = 'dFvsdd125ssE'
            var token = jwt.sign({ 
              token:this.isstatelogin.token,
              obj:objSend
             }, secret);
            window.open(this.urlTicket+'token/'+token, '_blank');
          },
          viewprofile(val,index){
            if(index > this.islogin){
              return
            }
            this.$store.commit('viewprofile',val)
            this.$router.push('/detail/profile')
          },
          checkvalue(element){
            return element.detailUser.length > 0
          },
          fetchdata(){ 
              HTTPMentor.defaults.headers.common.Authorization = `Bearer ${this.isstatelogin.token}`;
              HTTPMentor.post(`get/all/user`).then(res => {
              console.log(`get/all/user`,res.data.obj)
              this.value_mentor = res.data.obj.filter(search =>{
                return search.userLevel == 50
              }); 
              if(res.data.success){
               this.$emit('closeLoading')
              }else{
                this.$dialog.alert(`<p class="has-text-centered is-size-5">${res.data.message}</p>`);
              }
            })
            .catch(e => {
                console.log("get/all/user",e);
                this.$dialog.alert('<p class="has-text-centered is-size-5">Please check your network connection</p>');
             });
          },
          clickhide(){
            this.numberclick = 10
            this.showmore = true
          },
          clickshowall(){
            this.numberclick += this.getlanguageDynamic.length
            this.showmore = false
          },
          bookingmentor(val){
             var data = {
               step:1,
               time:"",
             }
            this.$store.commit('stepbooking',1)
            this.$store.commit('mentoridprofile',val.userId)
             this.isComponentModalActive = true
            // return
            // this.$router.push('booking/mentor')
          },
          remove(val,ii = 0){
            // this.obj_filter.investing
            if(val == 'investing' ){
              this.investing.splice(ii, 1)
              return
            }else if(val == 'ismenorinvest'){
              this.ismenorinvest.splice(ii, 1)
            }else if(val == 'price'){
              this.filterPrice.splice(ii, 1)
            }else if(val == 'language'){
              this.filterLang.splice(ii, 1)
            }else if(val == 'skill'){
              this.filterSkill.splice(ii, 1)
            }else if(val == 'issize'){
               this.issize.splice(ii, 1)
            }

            this.obj_filter[val] = null
          },
          clearfilters(){
              this.ismenorinvest = []
              this.filterPrice = []
              this.filterSkill = []
              this.filterLang = []
              this.obj_filter = {}
              this.investing =  []
              this.ismenorinvest= [],
              this.issize = []
          },
          gopath(val){
              this.$router.push(val)
          },
          openNav(){
            if(this.isfilter){
              this.$store.commit('profilemenumargin',false)
              this.isfilter = false
            }else{
               this.$store.commit('profilemenumargin',true)
              this.isfilter = true
            }
          },
          closeNav(){
              this.$store.commit('profilemenumargin',false)
              this.isfilter = false
          },
          checklangfilter(val){
            var data = val.detailUser[0].language.filter((val3) => {
                  return val3.name == this.obj_filter.language
                })
           return data
          },
          async fetchdatainvest(){
                let data ={
                    keyRequest:this.token
                }
                HTTPDynamic.defaults.headers.common.Authorization = `Bearer ${this.token}`;
                await HTTPDynamic.post(`api/get/form`,data)
                .then(res => {
                    console.log("api/get/form",res);  
                    if (res.data.success) {
                        this.interestedinvesting = res.data.obj.form[2].component.components[0].componentData[5].display
                        this.sizeinvestment = res.data.obj.form[2].component.components[0].componentData[5].display.value     
                    } 
                })
                .catch(e => {  
                    console.log("api/get/form/error",e);
                });
          }
        },
        // {{ ismenorinvest }}
        computed: {
          currency(){
            return this.$store.state.currency
          },
          ishideinvestmentmenu(){
            var data = this.ismenorinvest.filter((val) => {
                if(val.label == 'Investment'){
                  return val
                }
              })
           if(data.length > 0){
            // default show/hide
         
             this.showmoreInterest = true
             this.numberclickinterest = 10
             return true
           }else{
             // default value
            this.investing = []
            this.issize = []
             return false
           }
            // console.log(data)
          },
          filtervalue(){
            if(this.filterPrice == null ||  this.filterPrice.length == 0 ||  this.filterPrice.length == 2){
              return  this.value_mentor
            }
            let data = []
            if(this.filterPrice.length < 3){
              this.filterPrice.map(val =>{
                if(val == 'hiring'){
                  this.value_mentor.forEach(val => {
                    if(val.detailUser[0].amountHourly != null && val.detailUser[0].amountHourly > 0){
                      data.push(val)
                    }
                  });
                }else{
                  this.value_mentor.forEach(val => {
                    if(val.detailUser[0].amountHourly == null || val.detailUser[0].amountHourly < 1){
                      data.push(val)
                    }
                  });
                }
              })
            }
            console.log('filterlang',data)
            return data
            // this.value_mentor
            // if(this.filterPrice == 'free'){
            //   const result = this.value_mentor.filter((val) => {
            //   return val.detailUser[0].amountHourly < 25
            //    })
            //    return result
            // }else if(this.obj_filter.price == '25$-50$'){
            //   const result = this.value_mentor.filter((val) => {
            //      return  val.detailUser[0].amountHourly <= 50 && val.detailUser[0].amountHourly >= 25
            //    })
            //    return result
            // }else if(this.obj_filter.price == '50$-100$'){
            //   const result = this.value_mentor.filter((val) => {
            //      return  val.detailUser[0].amountHourly <= 100 && val.detailUser[0].amountHourly >= 50
            //    })
            //    return result
            // }else if(this.obj_filter.price == '100$ +'){
            //   const result = this.value_mentor.filter((val) => {
            //      return  val.detailUser[0].amountHourly >= 100
            //    })
            //    return result
            // }
          },
          filterlang(){
           if(this.filterLang.length == 0){
            return  this.filtervalue
           }
            let data = []
            this.filtervalue.forEach(val => {
              if(val.detailUser[0].language != null){
                let i = 0
                val.detailUser[0].language.filter(val2 => {
                  this.filterLang.map(res =>{
                    if(res == val2.name && i == 0){
                      i++
                      data.push(val)
                    }
                  })

                });
                i = 0
              }
            });
            console.log('filterlang',data)
            return data
          },
          filterexpertise(){
              if(this.filterSkill.length == 0){
                return  this.filterlang
              }
           let data = []
            this.filterlang.forEach(val => {
              if(val.detailUser[0].industryExpertise != null){
                let i = 0
                val.detailUser[0].industryExpertise.filter(val2 => {
                  this.filterSkill.map(res =>{
                    if(res == val2.name && i == 0){
                      i++
                      data.push(val)
                    }
                  })
                });
                i = 0
              }
            });
            console.log('filterexpertise',data)
            return data
          },
          filterinvesting(){
             if(this.investing.length == 0){
                return  this.filterexpertise
             }
            // console.log('dsadsadsaczxcz',this.filterexpertise)
            // var data5 = [];
            var result = this.filterexpertise.filter((p) => {
              if(typeof p.detailUser[0].industryInterested == 'undefined'){
                return this.filterexpertise
              }
                  var found = p.detailUser[0].industryInterested.findIndex((c) => {
                    var datac;
                    this.investing.forEach(d => {

                      if( d.label == c.name){
                        datac = (d.label == c.name)
                      }
                    });
                    // console.log(datac)
                   return datac
                  })
                // console.log('dsadsaczxc',found)
                return found !== -1
            })
            // console.log('xzcxzczxvcvasd',testData)
             return  result
          },
          filtermentorinvestment(){
            if(this.ismenorinvest.length == 0){
              return  this.filterinvesting
            }else{
              var found = this.filterinvesting.filter((element) =>{
                   var data2 = this.ismenorinvest.some(element2 => {
                    if(element2.label == 'Mentor' && element.detailUser[0].mentor == true){
                      return true
                    }
                    if(element2.label == 'Investment' && element.detailUser[0].investment == true){
                      return true
                    }
                  })
                return data2
              })
              return  found
            }
          },
          filtersizeofinvestment(){
             if(this.issize.length > 0){
                   var data5 = this.filtermentorinvestment.filter(val => {
                     var data6 =  val.detailUser[0].sizeInvestment.some(val2 =>{
                        var found4 =  this.issize.some(val4 => {
                          if(val2.name == val4.label){
                            return true
                          }
                       });
                       return found4
                     })
                     return data6
                })

                let mentor = []
                data5.map((item)=>{
                  if (item.detailUser.length > 0 && 
                      typeof item.detailUser[0].aboutMe !== 'undefined' &&
                      typeof item.detailUser[0].industryExpertise !== 'undefined' &&
                      typeof item.detailUser[0].profilePic !== 'undefined' &&
                      item.detailUser[0].aboutMe !== '' &&
                      item.detailUser[0].aboutMe !== null &&
                      item.detailUser[0].industryExpertise.length > 0 &&
                      item.detailUser[0].profilePic !== '' &&
                      item.detailUser[0].profilePic !== null) {
                    mentor.push(item)
                  }
                })

                let sort = mentor.sort((a, b) => {
                    const modifier = -1;
                    if (a.updatedAt < b.updatedAt) return -1 * modifier;
                    if (a.updatedAt > b.updatedAt) return 1 * modifier;
                    return 0;
                });
                
                return sort

             }else{
                let mentor = []
                this.filtermentorinvestment.map((item)=>{
                  if (item.detailUser.length > 0 && 
                      typeof item.detailUser[0].aboutMe !== 'undefined' &&
                      typeof item.detailUser[0].industryExpertise !== 'undefined' &&
                      typeof item.detailUser[0].profilePic !== 'undefined' &&
                      item.detailUser[0].aboutMe !== '' &&
                      item.detailUser[0].aboutMe !== null &&
                      item.detailUser[0].industryExpertise.length > 0 && 
                      item.detailUser[0].profilePic !== '' &&
                      item.detailUser[0].profilePic !== null) {
                    mentor.push(item)
                  }
                })

                let sort = mentor.sort((a, b) => {
                    const modifier = -1;
                    if (a.updatedAt < b.updatedAt) return -1 * modifier;
                    if (a.updatedAt > b.updatedAt) return 1 * modifier;
                    return 0;
                });

                return sort
             }
          },
          userLogin(){
            return this.$store.state.islogin
          },
          islogin(){
            // if login ,profile will not blur
            if(this.isstatelogin.userId){
              return this.value_mentor.length
            }else{
              return 2
            }
              
          },
          token(){
            return this.$store.state.token
          },
          isstatelogin(){
            return this.$store.state.islogin
           },
          allfilter(){
            if(this.radio && this.language){
              let data = {
                price : this.radio,
                language : this.language
              }
              this.obj_filter.push(data)
            }
          },
          getlanguageDynamic(){
            return this.$store.getters.getalllanguage
          },
        },
        created(){
          this.fetchdatainvest()
          this.fetchdata()
          // console.log('getProvinceDynamicgetProvinceDynamic',)
            this.isfilter = false
          this.$store.commit('profilemenumargin',false)
        }

};
</script>
<style lang="scss" scoped>
.hoverView{
  letter-spacing: 1px;
  color: #0fb9f4;
}
.profileContent{
  margin:0 auto;
  width: 140px;
  height: 140px;
  overflow: hidden;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 5px 5px 0px rgba(237,237,237,1);
}
.profileContent img{
  max-width:100%!important;
}
article{
  margin:0;
  border:1px solid #ebebeb;
  border-radius:5px;
  padding:15px;
}
.modal-card-body .card{
cursor: pointer;
}

.modal-card i{
  color:black !important;
  font-size:120px;
  margin-top: 5px
}
.level.is-mobile{
  position: relative; left: 1px;
}

.media{
  transition: 0.25s;
  cursor: pointer;
}
.media:hover{
  transform: scale(1.02)
}
.blurbutton{
      padding: 5px 2rem;
    filter: blur(0px);
    position: absolute;
    z-index: 38;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    background: linear-gradient(180deg, #FD7900 -34.44%, #FFCB2A 133.33%);
    border-radius: 40px;
}
.button.is-info.is-outlined:hover, .button.is-info.is-outlined:focus,.button.is-info{
  border-radius: 21px;
    border-color: #0D6ACA;
    
    background: white;
}
.button.is-info{
  color: #0D6ACA;
}
.orangebutton:hover,.orangebutton:focus,.orangebutton{
   border-radius: 21px !important;
    border-color: #FD7900 !important;
    color: #FD7900 !important;
    background: white !important;
    margin-bottom: 20px;
}
.b-radio.radio input[type=radio] + .check{
  border: 2px solid #DADADA !important;
  /* border-color: #DADADA; */
}
.media-left{
  text-align: center;
}
.media-content{
  position: relative;
}

.level-item{
  margin-right: 0.6rem;
}
i{

  justify-content: center;
}
.circle{
    border-radius: 50%;
    background: #0FB9F4;
    text-align: center;
    width: 30px;
    font-size: 13px;
    height: 30px;
    display: flex;
    position: relative;
        justify-content: center;
    align-items: center;
    color:#fff;
}
.circle span{
  color:white;
  font-weight: bold;
}
.circle:hover span{
  color:#0FB9F4;
  font-weight: bold;
}
.circle:hover{
  
  background: white;
  box-shadow: 0 0 0 1px #0FB9F4;
}
.circle:hover i{
   color: #0FB9F4;
}
article{
  border-radius: 5px;
  background: white;

  position: relative;
}
.underline{
  position: absolute;
  bottom: -20px;
  width: 100%;
  background: rgba(0,0,0,0.25);
  height: 1px;
}
.mb{
  margin-bottom: 5rem !important;
}
.blurprofile .blurcontent{
   filter: blur(3px);
   opacity: 0.5;
}

/* menumenumenu */
.sidenav {
      /* background: ; */
  box-shadow: -4px 0px 6px rgba(0, 0, 0, 0.08);
  z-index: 99;
  height: 100%;
  width: 0;
  position: fixed;
  top: 0;
  right: 0;
  background-color: white;
  overflow-x: hidden;
  transition: 0.5s;
  padding: 50px 20px 0 20px;
}

.sidenav a {
    padding: 0 0 10px 0;
    text-decoration: none;
    font-size: 16px;
    font-weight: bold;
    color: black;
    display: block;
    transition: 0.3s;
    text-align: left;
}
.sidenav a.language{
  display: inline-block;
  width: 45%;
  word-break: break-word;
}
.sidenav a:hover {
 color: black;
}

.sidenav .closebtn {
  position: absolute;
  top: 0;
  right: 25px;
  font-size: 36px;
  margin-left: 50px;
}

/* #main {
  transition: margin-left .5s;
  padding: 16px;
} */

#closesidebar{
  width: 0;
  padding: 0;
  opacity: 0;
  margin-left: 0;
}
.media-content{
  overflow: hidden;
}
/* #mySidenav.notactivesidenav{
    width: 0;
    padding: 0;
}
.notactivesidenav #closesidebar{
  width: 0;
  padding: 0;
  opacity: 0;
  margin-left: 0
} */

#mySidenav{
  position:fixed;
  width:20%;
  right:-100%;
  transition: all 1s;
  --webkit-transition: all 1s;
  padding:50px 20px 0 20px;
  z-index: 100
}
#mySidenav.activesidenav{
  right:0px;
  
}

.activesidenav #closesidebar{
  width:100%;
  opacity:1;
 transition: 0.5s
}

.marginfilter{
  margin:5px auto;
}


#Filters.Filters{
  right: 1px;
  display:block;float:right;padding: 0 2rem;
  border:none;
  border: 1px solid #0D6ACA !important;
  background: white;
  border-radius: 40px;
  transition: all 0.3s;
  --webkit-transition: all 0.3s;
}
#Filters.activefilter{
  border: 1px solid #0D6ACA !important;
  background: transparent !important;
}

#Filters.activefilter span,#Filters.activefilter i{
  color: #0D6ACA !important;
}

#Filters .white{
  color:white;
}
#Filters:hover{
  /* box-shadow: 0 0 0 1px #0D6ACA !important;*/
  border: 1px solid #0FB4F1!important; 
  background: linear-gradient(180deg, #0D6ACA 0%,#0FB4F1 100%); 
  color:white;
}


.objfilter{
  /* float: left; */
    background: linear-gradient(180deg, #FD7900 -34.44%, #FFCB2A 133.33%);
    padding-left: .5rem;
    padding-right: .5rem;
    padding-top: .25rem;
    padding-bottom: .25rem;
    display: inline-block;
    color: white;
    border-radius: 40px;
    cursor: pointer;
    margin-top: 10px;
}
.objfilter:hover{
      background: white;
    box-shadow: 0 0 0 1px #FD7900;
    color: #FD7900;
}
.objfilter:hover .fas{
  color: #FD7900;
}


@media only screen and (max-width: 769px) {
  .columnrespons{
    width: 50%;
    float: left
  }
  #mySidenav{
    width:100%;
  }
  .media-left{
    margin-right:0;
  }
}  
@media only screen and (min-width: 770px) and  (max-width: 1024px) {
  #mySidenav{
    width:40%;
  }
}

@media only screen and (max-width: 414px) {
  .contenttext{
        text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    display: -webkit-box;
    -webkit-line-clamp: 5;
  }
}

@media only screen and (max-width: 403px) {
  .activesidenav #closesidebar{
    width:100%;
  }
}

@media only screen and (max-width: 375px) {
  .media{
    display: block;
  }
  article{
    padding:15px;
    /* top: 0px; */
  }
  .media-content{
    width: 100% !important;
  }
  #Filters.Filters{
    margin: 0 auto;
    float: initial;
    margin-bottom: 10px;
  }
}

@media only screen and (max-width: 355px) {
  .columnrespons{
    width: 100%;
    float: left
  }
  article{
    top: 120px;
 }
 .columnrespons{
   text-align: center;
 }
} 

@media screen and (max-height: 450px) {
  .sidenav {
    padding-top: 15px;
  }
  .sidenav a {
    font-size: 18px;
  }
}
.font-size-15{
		font-size: 15px;
}
.star-gray{
  color:#C4C4C4;
}
.button.is-info.is-outlined:focus{
  color: #167df0!important;
}
.flex-center{
  display:flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  line-height: 2.5rem;
}
</style>